// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__1Vn4h","liItems":"List_liItems__1x39_","groupHeader":"List_groupHeader__2HTuU"};